/**
 * Các options khi chọn tại combobox Tổng hợp của form tham số báo cáo
 * nxhinh 03.01.2024
 * enum sửa lỗi cho báo cáo 32 PTC
 */
export default {
  AllDistrict: 2,
  District: 0,
  Ward: 1,
};
